"use client";

import { cn } from "@devhop/ui";
import { PackageIcon, StoreIcon } from "lucide-react";

export type WorkshopPartAddSourceMode = "shop" | "customer";

export function WorkshopPartSourceChoice({
  onSelect,
  className,
}: {
  onSelect: (mode: WorkshopPartAddSourceMode) => void;
  className?: string;
}) {
  return (
    <div className={cn("grid gap-3 sm:grid-cols-2", className)}>
      <button
        type="button"
        className="flex min-h-32 flex-col items-start gap-2 rounded-2xl border-2 border-border bg-background p-4 text-left transition hover:border-primary/50 hover:bg-primary/5"
        onClick={() => onSelect("shop")}
      >
        <span className="inline-flex size-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <StoreIcon className="size-5" />
        </span>
        <span className="font-semibold text-base">ອາໄຫຼ່ຮ້ານ</span>
        <span className="text-muted-foreground text-xs leading-relaxed">
          ເລືອກຈາກສາງ, ຈອງສະຕ໋ອກ ຫຼື ສັ່ງ Marketplace
        </span>
      </button>

      <button
        type="button"
        className="flex min-h-32 flex-col items-start gap-2 rounded-2xl border-2 border-violet-200 bg-violet-50/50 p-4 text-left transition hover:border-violet-400 hover:bg-violet-50"
        onClick={() => onSelect("customer")}
      >
        <span className="inline-flex size-10 items-center justify-center rounded-xl bg-violet-100 text-violet-700">
          <PackageIcon className="size-5" />
        </span>
        <span className="font-semibold text-base text-violet-950">
          ລູກຄ້ານຳມາ
        </span>
        <span className="text-violet-900/70 text-xs leading-relaxed">
          ບັນທຶກອາໄຫຼ່ທີ່ລູກຄ້າເອມາເອງ — ບໍ່ຫັກຄ່າອາໄຫຼ່
        </span>
      </button>
    </div>
  );
}
